import { FC } from 'react'
import TimeOffRequests from '../../../pages/Requestor/ListsTabs/TimeOffRequests'
import TimeOffRequestsHistory from '../../../pages/Requestor/ListsTabs/TimeOffRequestsHistory'
import VacationBidding from '../../../pages/Requestor/ListsTabs/VacationBidding'
import ApproverRequests from '../../../pages/Approver/ListPages/ApproverRequests'
import ApproverHistory from '../../../pages/Approver/ListPages/ApproverHistory'

export interface TabData {
  id: number
  title: string
  component: FC<any>
}

export const requestsListsData: TabData[] = [
  {
    id: 1,
    title: 'My Time Off Requests',
    component: TimeOffRequests,
  },
  {
    id: 2,
    title: 'History',
    component: TimeOffRequestsHistory,
  },
  {
    id: 3,
    title: 'Vacation Bidding',
    component: VacationBidding  ,
  },
]

export const approverRequestsListsData: TabData[] = [
  {
    id: 1,
    title: 'Incoming Time Off Requests',
    component: ApproverRequests,
  },
  {
    id: 2,
    title: 'History',
    component: ApproverHistory,
  },
]
